import { Component } from "react";
import api from "../../utils/axios";
import Select from "react-select";
import $ from "jquery";
import { format } from "date-fns";
import { adminlimit, downloadUrl } from "../Settings/Config";
import { showContaimerLoader, showPageCount, showDate, calculateStatus_, showDateTime, showHTMLText, showLoader, hideLoader, getDaysBetweenDates, showDBDate } from "../Settings/Settings";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Pagenation from "../Layout/Pagenation";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import dashboardfield from "./dashboard.json";
import { addDays } from "date-fns";
const module = "dashboard";
const moduleName = "Nemo Dashboard";
const cards = [
  { title: "Total Calls", change: "+88", icon: "fa-phone", color: "#ff0000cc", key: "totalcalls" },
  { title: "Created", change: "+17", icon: "fa-plus", color: "#008000", key: "candidateCreated" },
  { title: "Proposed", icon: "fa-product-hunt", color: "#008000", key: "proposed_count" },
  { title: "Approved", icon: "fa-check", color: "#008000", key: "approved_count" },
  { title: "Joined", icon: "fa-handshake-o", color: "#008000", key: "joined_count" },
  { title: "Rejected", icon: "fa-times", color: "#ff0000cc", key: "rejected_count" },
  { title: "Sign On", icon: "fa-sign-in", color: "#008000", key: "signOnCount" },
  { title: "Sign Off", icon: "fa-sign-out", color: "#ff0000cc", key: "signOffCount" },
];

const contractcards = [
  { title: "On Board", icon: "fa-id-badge", color: "#008000", key: "OnBoard" },
  { title: "Due for Sign Off", change: "+17", icon: "fa-hourglass", color: "#008000", key: "dueforSignOff" },
  { title: "EOC Expired", icon: "fa-calendar-times-o", color: "#ff0000cc", key: "eocExpired" },
  { title: "Due for Renewal", icon: "fa-calendar", color: "#ff0000cc", key: "dueforRenewal" },
  { title: "Expired Documents", icon: "fa-calendar-times-o", color: "#ff0000cc", key: "expiredDocuments" },
  { title: "Sign On DG", icon: "fa-sign-in", color: "#008000", key: "signOnDG" },
  { title: "Sign Off DG", icon: "fa-sign-out", color: "#ff0000cc", key: "signOffDG" },
  { title: "AOA Pending", icon: "fa-file-text-o", color: "#ff0000cc", key: "aOAPending" },
  { title: "Contract Pending", icon: "fa-file-text-o", color: "#ff0000cc", key: "contractPending" },
  { title: "Vessel Position", icon: "fa-solid fa-ship", color: "#ff0000cc", key: "vesselposition" },
];

const renderDocStatus = (available) =>
  available ? (
    <i className="fa fa-check-circle" style={{ color: "#008000" }} aria-hidden="true"></i>
  ) : (
    <i className="fa fa-times-circle" style={{ color: "#ff0000cc" }} aria-hidden="true"></i>
  );

class List extends Component {
  constructor(props) {
    super(props);
    const $this_ = this;
    this.state = {
      windowHeight: window.innerHeight,
      pageLimit: { label: adminlimit, value: adminlimit },
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      pageLimitMedical: { label: adminlimit, value: adminlimit },
      totalRecordsMedical: 0,
      totalPageMedical: 0,
      currentPageMedical: 1,
      loading: true,
      contractLoading: true,
      viewDocumentFile: "",
      viewDocumentTitle: "",
      searchKeywords: "",
      days: 1,
      totalcalls: 0,
      candidateCreated: 0,
      proposed_count: 0,
      approved_count: 0,
      joined_count: 0,
      rejected_count: 0,
      signOnCount: 0,
      signOffCount: 0,
      OnBoard: 0,
      dueforSignOff: 0,
      eocExpired: 0,
      dueforRenewal: 0,
      expiredDocuments: 0,
      signOnDG: 0,
      signOffDG: 0,
      aOAPending: 0,
      contractPending: 0,
      vesselposition: 0,
      vlsposstartdate:"",
      vlsposend:"",
      rankWiseloading: false,
      chartOptions: {
        chart: {
          type: "bar",
          height: 300,
        },

        title: {
          text: "Rank Wise Calls Made - Today",
        },

        xAxis: {
          categories: [],
        },

        yAxis: {
          min: 0,
          title: {
            text: "",
          },

          stackLabels: {
            enabled: true,
          },
        },

        legend: {
          enabled: true,
          align: "center",
          verticalAlign: "bottom",
        },

        plotOptions: {
          series: {
            stacking: "normal",

            dataLabels: {
              enabled: true,
              inside: true,

              formatter: function () {
                return this.y > 0 ? this.y : "";
              },

              style: {
                color: "#fff",
                fontWeight: "bold",
                textOutline: "1px black",
              },
            },
          },
        },

        series: [],
      },
      rankWiseAvailloading: false,
      rankWiseAvailchartOptions: {
        chart: {
          type: "bar",
          height: 300,
          animation: {
            duration: 500,
          },

          spacingLeft: 0,
          marginLeft: 140,
          marginRight: 20,
        },

        title: {
          text: "Rank Wise Available Candidate",
          align: "left",
        },

        subtitle: {
          floating: true,
          align: "right",
          verticalAlign: "middle",
          useHTML: true,
          y: -80,
          x: -100,
        },

        legend: {
          enabled: false,
        },

        xAxis: {
          type: "category",

          /*  lineWidth: 0,
           tickWidth: 0, */

          minPadding: 0,
          maxPadding: 0,

          startOnTick: false,
          endOnTick: false,
        },

        yAxis: {
          opposite: true,
          tickPixelInterval: 150,
          /*  gridLineWidth: 0, */

          title: {
            text: null,
          },

          labels: {
            enabled: false,
          },
        },

        plotOptions: {
          series: {
            animation: false,

            borderWidth: 0,

            colorByPoint: true,

            pointWidth: 25,

            groupPadding: 0.05,
            pointPadding: 0,

            dataSorting: {
              enabled: true,
              matchByName: true,
            },

            dataLabels: {
              enabled: true,
            },

            point: {
              events: {
                click: function () {
                  $this_.viewRankWiseAvailableCandidate(this.options.name);
                  //window.open(`/daily-stats.html?type=RankWiseAvailableCandidate&rankName=${this.options.name}`, "_blank");
                },
              },
            },
          },
        },

        series: [],

        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 550,
              },

              chartOptions: {
                xAxis: {
                  visible: false,
                },

                subtitle: {
                  x: 0,
                },

                plotOptions: {
                  series: {
                    dataLabels: [
                      {
                        enabled: true,
                        y: 8,
                      },
                      {
                        enabled: true,
                        format: "{point.name}",
                        y: -8,
                        style: {
                          fontWeight: "normal",
                          opacity: 0.7,
                        },
                      },
                    ],
                  },
                },
              },
            },
          ],
        },
      },
      userWiseLoading: false,
      userCallschartOptions: {
        chart: {
          type: "column",
          spacingRight: 0,
        },

        xAxis: {
          type: "category",
          maxPadding: 0,
          minPadding: 0,
          labels: {
            autoRotation: [-45, -90],
            style: {
              fontSize: "13px",
              fontFamily: "Verdana, sans-serif",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Call Count",
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          pointFormat: "<b>{point.y} Calls</b>",
        },
        series: [],
      },

      userCreatedchartOptions: {
        chart: {
          type: "column",
        },

        xAxis: {
          type: "category",
          labels: {
            autoRotation: [-45, -90],
            style: {
              fontSize: "13px",
              fontFamily: "Verdana, sans-serif",
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Call Count",
          },
        },
        legend: {
          enabled: false,
        },
        tooltip: {
          pointFormat: "<b>{point.y} Profiles created</b>",
        },
        series: [],
      },

      userWisechartOptions: {
        chart: {
          type: "column",
        },
        title: {
          text: "User Wise Statistics",
          align: "left",
        },

        yAxis: {
          min: 0,
          title: {
            text: "Total Count",
          },
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            pointWidth: 20, // Set the bar width in pixels
          },
        },
      },
      rankList: [],
      userandRankWiseList: [],
      userList: [],
      filterByUser: false,
      filterByUserDetails: "",
      selectedlistTypeLoading: false,
      viewTitle: "",
      viewCount: 0,
      selectedlistType: "",
      selectedRank: "",
      selectedlistData: [],
      selectedlistDataMedical: [],
      selectVessel: "",
      activeTab: "",
      vessleList:[],
      vesselID:"",
      birthdayLoading: false,
      birthdayReminderList: [],
      birthdayStartDate: "",
      birthdayEndDate: "",
      birthdaySearchKeywords: "",
      birthdayPageLimit: { label: adminlimit, value: adminlimit },
      birthdayCurrentPage: 1,
      birthdayTotalPage: 0,
      birthdayTotalRecords: 0,
      reminderLoading: false,
      reminderList: [],
      reminderStartDate: "",
      reminderEndDate: "",
      reminderSearchKeywords: "",
      reminderPageLimit: { label: adminlimit, value: adminlimit },
      reminderCurrentPage: 1,
      reminderTotalPage: 0,
      reminderTotalRecords: 0,
      pendingDocumentLoading: false,
      pendingDocumentList: [],
      pendingDocumentSearchKeywords: "",
      pendingDocumentVessel: "",
      pendingDocumentPageLimit: { label: adminlimit, value: adminlimit },
      pendingDocumentCurrentPage: 1,
      pendingDocumentTotalPage: 0,
      pendingDocumentTotalRecords: 0,
    };
  }

  componentDidMount() {
    this.loadList(true);
    this.loadRankWiseList(true);
    this.getavailableCandidate();
    this.loadUserWiseList();
    window.addEventListener("resize", this.handleResize);
    this.loadDropdown();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  loadDropdown() {
      api
        .get("vessel/activedropdown")
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ vessleList: res.data.result });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }

  handleResize = () => {
    this.setState({
      windowHeight: window.innerHeight,
    });
  };
  selectReportType(days) {
    this.setState({ days, loading: true }, () => {
      this.loadList();
      this.loadRankWiseList();
    });
  }
  loadList(inititalLoad = false) {
    const days = this.state.days;
    let addParam = `days=${days}`;

    const selectedUserValue = this.state.filterByUserDetails?.value || "";
    const selectedUserLabel = this.state.filterByUserDetails?.label || "";
    if (selectedUserValue !== "") {
      addParam += `&selectedUserValue=${selectedUserValue}&&selectedUserLabel=${selectedUserLabel}`;
    }

    api
      .get(`${module}/get-count?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          const resdata = res.data.result;
          console.log(resdata, "aaaaresdataresdataresdata");
          this.setState({
            totalcalls: resdata?.totalcalls || 0,
            candidateCreated: resdata?.candidateCreated || 0,
            proposed_count: resdata?.proposed_count || 0,
            approved_count: resdata?.approved_count || 0,
            joined_count: resdata?.joined_count || 0,
            rejected_count: resdata?.rejected_count || 0,
            signOnCount: resdata?.signOnCount || 0,
            signOffCount: resdata?.signOffCount || 0,
            loading: false,
          });
          if (inititalLoad) {
            this.setState({
              OnBoard: resdata?.OnBoard || 0,
              dueforSignOff: resdata?.dueforSignOff || 0,
              eocExpired: resdata?.eocExpired || 0,
              dueforRenewal: resdata?.dueforRenewal || 0,
              expiredDocuments: resdata?.expiredDocuments || 0,
              signOnDG: resdata?.signOnDG || 0,
              signOffDG: resdata?.signOffDG || 0,
              aOAPending: resdata?.aOAPending || 0,
              contractPending: resdata?.contractPending || 0,
              vesselposition: resdata?.vesselposition || 0,
              contractLoading: false,
            });
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  loadRankWiseList(inititalLoad = false) {
    this.setState({ rankWiseloading: true });
    const days = this.state.days;
    let addParam = `days=${days}`;
    api
      .get(`${module}/get-rank-wise-count?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          console.log(res.data.result, "bbbbres.data.result");
          const disscussionList = res.data.result.disscussionList;
          const userDisscussionList = res.data.result.userDisscussionList;

          console.log(disscussionList, "disscussionListdisscussionList");
          const categories = disscussionList.map((item) => item.discussionranks);
          const connectedData = disscussionList.map((item) => parseInt(item.yesCount));
          const notConnectedData = disscussionList.map((item) => parseInt(item.noCount));

          let dayDisply = "Today";
          if (this.state.days === 2) {
            dayDisply = "Yesterday";
          } else if (this.state.days === 7) {
            dayDisply = "Last 7 Days";
          } else if (this.state.days === 30) {
            dayDisply = "Lst 30 Days";
          }

          this.setState({
            chartOptions: {
              ...this.state.chartOptions,
              title: {
                text: `Rank Wise Calls Made - ${dayDisply}`,
              },
              chart: {
                type: "bar",
                height: categories.length <= 1 ? 250 : categories.length * 100,
              },
              xAxis: {
                categories: categories,
              },

              series: [
                {
                  name: "Not Connected",
                  color: "#c2a383",
                  data: notConnectedData,
                },
                {
                  name: "Connected",
                  color: "green",
                  data: connectedData,
                },
              ],
            },
          });

          // Get unique ranks
          const rankList = [...new Set(userDisscussionList.map((item) => item.discussionranks))];

          const userandRankWiseList = Object.values(
            userDisscussionList.reduce((acc, item) => {
              if (!acc[item.userName]) {
                acc[item.userName] = {
                  userName: item.userName,
                  rank: [],
                };
              }

              acc[item.userName].rank.push(item);

              return acc;
            }, {}),
          );
          this.setState({ rankList, userandRankWiseList });
          this.setState({ rankWiseloading: false });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ rankWiseloading: false });
      });
  }
  getavailableCandidate() {
    this.setState({ rankWiseAvailloading: true });
    api
      .get(`${module}/get-available-candidate`)
      .then((res) => {
        if (res.data.status === "ok") {
          const availableList = res.data.result || [];
          const convertedList = availableList.length > 0 ? availableList.map((item) => [item.c_rank, item.totalcandidate]) : [];

          this.setState({
            rankWiseAvailchartOptions: {
              ...this.state.rankWiseAvailchartOptions,

              chart: {
                ...this.state.rankWiseAvailchartOptions.chart,

                height: convertedList.length <= 1 ? 120 : convertedList.length * 70,
              },

              series: [
                {
                  type: "bar",
                  name: "",
                  data: convertedList,
                },
              ],
            },

            rankWiseAvailloading: false,
          });
        }
      })
      .catch((err) => {
        console.error(err);
        this.setState({ rankWiseAvailloading: false });
      });
  }

  loadUserWiseList() {
    this.setState({ userWiseLoading: true });
    const days = this.state.days;
    let addParam = `days=${days}`;
    api
      .get(`${module}/get-user-stats?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          const response = res.data;
          const userList = response?.users || [];
          this.setState({ userList });
          let dayDisply = "Today";
          if (this.state.days === 2) {
            dayDisply = "Yesterday";
          } else if (this.state.days === 7) {
            dayDisply = "Last 7 Days";
          } else if (this.state.days === 30) {
            dayDisply = "Lst 30 Days";
          }
          this.setState({
            userCallschartOptions: {
              ...this.state.userCallschartOptions,
              title: {
                text: `${dayDisply} Total Calls`,
              },
              plotOptions: {
                column: {
                  pointPadding: 0.1,
                  groupPadding: 0.05,
                  maxPointWidth: 60,
                },
              },
              startOnTick: false,
              endOnTick: false,
              series: [
                {
                  name: "Call Count",
                  colorByPoint: true,
                  groupPadding: 0,
                  pointWidth: 50, // reduce width
                  data: response.totalCallList,
                  dataLabels: {
                    enabled: true,
                    rotation: -90,
                    color: "#FFFFFF",
                    inside: true,
                    verticalAlign: "top",
                    format: "{point.y}",
                    y: 10,
                    style: {
                      fontSize: "13px",
                      fontFamily: "Verdana, sans-serif",
                    },
                  },
                },
              ],
            },
          });

          this.setState({
            userCreatedchartOptions: {
              ...this.state.userCreatedchartOptions,
              title: {
                text: `${dayDisply} Total Created`,
              },
              plotOptions: {
                column: {
                  pointPadding: 0.1,
                  groupPadding: 0.05,
                  maxPointWidth: 60,
                },
              },
              startOnTick: false,
              endOnTick: false,
              series: [
                {
                  name: "Candidate Count",
                  colorByPoint: true,
                  groupPadding: 0,
                  pointWidth: 50, // reduce width
                  data: response.createdList,
                  dataLabels: {
                    enabled: true,
                    rotation: -90,
                    color: "#FFFFFF",
                    inside: true,
                    verticalAlign: "top",
                    format: "{point.y}",
                    y: 10,
                    style: {
                      fontSize: "13px",
                      fontFamily: "Verdana, sans-serif",
                    },
                  },
                },
              ],
            },
          });
          console.log(response.currentUser, response.chartdata, "esponse.currentUseresponse.currentUser");
          this.setState({
            userWisechartOptions: {
              ...this.state.userWisechartOptions,
              xAxis: {
                categories: response.currentUser,
                crosshair: true,
                accessibility: {
                  description: "Countries",
                },
              },
              series: response.chartdata,
            },
          });
          this.setState({ userWiseLoading: false });
        }
      })
      .catch((err) => {
        this.setState({ userWiseLoading: false });
        console.error(err);
      });
  }

  handleChangeCheckbox(name, event) {
    const checked = event.target.checked;
    this.setState({ [name]: checked });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value }, () => {
      this.loadList();
    });
  }

  handleDateChange(name, value) {
    this.setState({ [name]: value });
  }

  
  viewDetails(selectedlistType, title, viewCount) {
    if (parseInt(viewCount) > 0) {
      $("#viewDetails").trigger("click");
      this.viewFileBack();
      this.setState({ selectedlistType: selectedlistType, viewTitle: title, viewCount: viewCount, searchKeywords: "" }, () => {
        this.loadDetailsList(1);
      });
    }
  }
  loadDetailsList(offset) {
    showLoader("seletedDataList");
    const days = this.state.days;
    const selectedlistType = this.state.selectedlistType;
    const selectVessel = this.state.selectVessel;
    const selectedRank = this.state.selectedRank;
    const searchKeywords = this.state.searchKeywords;

    let addParam = `limit=${this.state.pageLimit.value}&page=${offset}&days=${days}&type=${selectedlistType}${selectVessel !== "" ? "Vessel" : ""}`;
    if (selectVessel !== "") {
      addParam += `&vessleID=${selectVessel}`;
    }
    if (selectedRank) {
      addParam += `&rankName=${selectedRank}`;
    }
    if (searchKeywords) {
      addParam += `&searchKeywords=${searchKeywords}`;
    }

    const vlsposstartdate = this.state.vlsposstartdate;
    if(vlsposstartdate!=="") {
      addParam +=`&vlsposstartdate=${showDBDate(vlsposstartdate)}`
    }
    const vlsposend = this.state.vlsposend;
    if(vlsposend!=="") {
      addParam +=`&vlsposend=${showDBDate(vlsposend)}`
    }

    const vesselID = this.state.vesselID;
    if(vesselID!=="") {
      addParam +=`&vesselID=${vesselID?.value||''}`
    }    

    const selectedUserValue = this.state.filterByUserDetails?.value || "";
    const selectedUserLabel = this.state.filterByUserDetails?.label || "";
    if (selectedUserValue !== "") {
      addParam += `&selectedUserValue=${selectedUserValue}&&selectedUserLabel=${selectedUserLabel}`;
    }
    

    api
      .get(`${module}/get-user-stats-list?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.listData;
          this.setState({ selectedlistData: result });
          if (offset === 1) {
            this.setState({ totalRecords: res.data.totalRecord, totalPage: res.data.totalPage });
          }
        }
        hideLoader("seletedDataList");
      })
      .catch((err) => {
        hideLoader("seletedDataList");
        console.error(err);
      });
    if (selectedlistType === "dueforRenewal" || selectedlistType === "expiredDocuments") {
      this.loadMedicalData(1);
    }
  }
  loadMedicalData(offset) {
    const days = this.state.days;
    const selectVessel = this.state.selectVessel;
    const selectedlistType__ = this.state.selectedlistType;
    let addParam = `limit=${this.state.pageLimit.value}&page=${offset}&days=${days}&type=${selectedlistType__}Medical${selectVessel !== "" ? "Vessel" : ""}`;
    if (selectVessel !== "") {
      addParam += `&vessleID=${selectVessel}`;
    }

    const selectedUserValue = this.state.filterByUserDetails?.value || "";
    const selectedUserLabel = this.state.filterByUserDetails?.label || "";
    if (selectedUserValue !== "") {
      addParam += `&selectedUserValue=${selectedUserValue}&&selectedUserLabel=${selectedUserLabel}`;
    }
    api
      .get(`${module}/get-user-stats-list?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.listData;
          this.setState({ selectedlistDataMedical: result });

          if (offset === 1) {
            this.setState({ totalRecordsMedical: res.data.totalRecord, totalPageMedical: res.data.totalPage });
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  sateValChange = (field, value, addParam) => {
    if (field === "page") {
      if (addParam === "Medical") {
        this.setState(
          {
            currentPageMedical: value,
          },
          () => {
            this.loadMedicalData(value);
          },
        );
      } else {
        this.setState(
          {
            currentPage: value,
          },
          () => {
            this.loadDetailsList(value);
          },
        );
      }
    } else if (field === "pageLimit") {
      if (addParam === "Medical") {
        this.setState({ pageLimitMedical: value, currentPageMedical: 1 }, () => {
          this.loadMedicalData(1);
        });
      } else {
        this.setState({ pageLimit: value, currentPage: 1 }, () => {
          this.loadDetailsList(1);
        });
      }
    }
  };
  closePopup(e) {
    e.preventDefault();
    //$('#extralargemodal').modal('hide');
    this.setState({
      selectedlistType: "",
      selectedlistData: [],
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      selectVessel: "",
      viewCount: 0,
    });
    hideLoader("seletedDataList");
  }
  onSelectVessel(selectVessel, e) {
    e.preventDefault();
    this.setState({ selectVessel, selectedlistData: [], totalRecords: 0, totalPage: 0, currentPage: 1, searchKeywords: "" }, () => {
      this.loadDetailsList(1);
    });
  }
  viewFile(viewDocumentFile, viewDocumentTitle, e) {
    e.preventDefault();
    this.setState({ viewDocumentFile, viewDocumentTitle });
  }
  viewFileBack() {
    this.setState({ viewDocumentFile: "", viewDocumentTitle: "" });
  }
  setactiveTab(activeTab, e) {
    e.preventDefault();
    this.setState({ activeTab });
  }
  viewRankWiseAvailableCandidate(rankName) {
    $("#viewDetails").trigger("click");
    this.setState({ selectedlistType: "rankWiseAvailableCandidate", selectedRank: rankName, viewTitle: `Available candidate for ${rankName}` }, () => {
      this.loadDetailsList(1);
    });
  }

  openBirthdayReminder(e) {
    e.preventDefault();
    $("#viewBirthdayReminder").trigger("click");
    this.setState(
      {
        birthdayStartDate: "",
        birthdayEndDate: "",
        birthdaySearchKeywords: "",
        birthdayPageLimit: { label: adminlimit, value: adminlimit },
        birthdayCurrentPage: 1,
        birthdayReminderList: [],
        birthdayTotalPage: 0,
        birthdayTotalRecords: 0,
      },
      () => {
        this.loadBirthdayReminder(1);
      },
    );
  }

  closeBirthdayReminder(e) {
    e.preventDefault();
    e.currentTarget.blur();
    this.setState({
      birthdayReminderList: [],
      birthdayStartDate: "",
      birthdayEndDate: "",
      birthdaySearchKeywords: "",
      birthdayCurrentPage: 1,
      birthdayTotalPage: 0,
      birthdayTotalRecords: 0,
    });
  }

  handleBirthdayDateChange(name, value) {
    this.setState({ [name]: value });
  }

  birthdaySearchBirthdayReminder(e) {
    e.preventDefault();
    this.setState({ birthdayCurrentPage: 1 }, () => {
      this.loadBirthdayReminder(1);
    });
  }

  birthdaySateValChange = (field, value) => {
    if (field === "page") {
      this.setState({ birthdayCurrentPage: value }, () => {
        this.loadBirthdayReminder(value);
      });
    }
  };

  loadBirthdayReminder(offset) {
    showLoader("birthdayReminderList");
    this.setState({ birthdayLoading: true });
    const { birthdayStartDate, birthdayEndDate, birthdaySearchKeywords, birthdayPageLimit } = this.state;

    let addParam = `page=${offset}&limit=${birthdayPageLimit?.value || adminlimit}`;
    if (birthdayStartDate !== "") {
      addParam += `&startDate=${showDBDate(birthdayStartDate)}`;
    }
    if (birthdayEndDate !== "") {
      addParam += `&endDate=${showDBDate(birthdayEndDate)}`;
    }
    if (birthdaySearchKeywords !== "") {
      addParam += `&searchKeywords=${birthdaySearchKeywords}`;
    }

    api
      .get(`${module}/get-birthday-reminder?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ birthdayReminderList: res.data.listData || [], birthdayLoading: false });
          if (offset === 1) {
            this.setState({ birthdayTotalRecords: res.data.totalRecord || 0, birthdayTotalPage: res.data.totalPage || 0 });
          }
        } else {
          this.setState({ birthdayLoading: false });
        }
        hideLoader("birthdayReminderList");
      })
      .catch((err) => {
        console.error(err);
        this.setState({ birthdayLoading: false });
        hideLoader("birthdayReminderList");
      });
  }

  openReminderList(e) {
    e.preventDefault();
    $("#viewReminderList").trigger("click");
    this.setState(
      {
        reminderStartDate: "",
        reminderEndDate: "",
        reminderSearchKeywords: "",
        reminderPageLimit: { label: adminlimit, value: adminlimit },
        reminderCurrentPage: 1,
        reminderList: [],
        reminderTotalPage: 0,
        reminderTotalRecords: 0,
      },
      () => {
        this.loadReminderList(1);
      },
    );
  }

  closeReminderList(e) {
    e.preventDefault();
    e.currentTarget.blur();
    this.setState({
      reminderList: [],
      reminderStartDate: "",
      reminderEndDate: "",
      reminderSearchKeywords: "",
      reminderCurrentPage: 1,
      reminderTotalPage: 0,
      reminderTotalRecords: 0,
    });
  }

  handleReminderDateChange(name, value) {
    this.setState({ [name]: value });
  }

  reminderSearchList(e) {
    e.preventDefault();
    this.setState({ reminderCurrentPage: 1 }, () => {
      this.loadReminderList(1);
    });
  }

  reminderSateValChange = (field, value) => {
    if (field === "page") {
      this.setState({ reminderCurrentPage: value }, () => {
        this.loadReminderList(value);
      });
    }
  };

  loadReminderList(offset) {
    showLoader("reminderListTable");
    this.setState({ reminderLoading: true });
    const { reminderStartDate, reminderEndDate, reminderSearchKeywords, reminderPageLimit } = this.state;

    let addParam = `page=${offset}&limit=${reminderPageLimit?.value || adminlimit}`;
    if (reminderStartDate !== "") {
      addParam += `&startDate=${showDBDate(reminderStartDate)}`;
    }
    if (reminderEndDate !== "") {
      addParam += `&endDate=${showDBDate(reminderEndDate)}`;
    }
    if (reminderSearchKeywords !== "") {
      addParam += `&searchKeywords=${reminderSearchKeywords}`;
    }

    api
      .get(`${module}/get-reminder-list?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ reminderList: res.data.listData || [], reminderLoading: false });
          if (offset === 1) {
            this.setState({ reminderTotalRecords: res.data.totalRecord || 0, reminderTotalPage: res.data.totalPage || 0 });
          }
        } else {
          this.setState({ reminderLoading: false });
        }
        hideLoader("reminderListTable");
      })
      .catch((err) => {
        console.error(err);
        this.setState({ reminderLoading: false });
        hideLoader("reminderListTable");
      });
  }

  openPendingDocument(e) {
    e.preventDefault();
    $("#viewPendingDocument").trigger("click");
    this.setState(
      {
        pendingDocumentSearchKeywords: "",
        pendingDocumentVessel: "",
        pendingDocumentPageLimit: { label: adminlimit, value: adminlimit },
        pendingDocumentCurrentPage: 1,
        pendingDocumentList: [],
        pendingDocumentTotalPage: 0,
        pendingDocumentTotalRecords: 0,
      },
      () => {
        this.loadPendingDocumentList(1);
      },
    );
  }

  closePendingDocument(e) {
    e.preventDefault();
    this.setState({
      pendingDocumentList: [],
      pendingDocumentSearchKeywords: "",
      pendingDocumentVessel: "",
      pendingDocumentCurrentPage: 1,
      pendingDocumentTotalPage: 0,
      pendingDocumentTotalRecords: 0,
    });
  }

  pendingDocumentSearchList(e) {
    e.preventDefault();
    this.setState({ pendingDocumentCurrentPage: 1 }, () => {
      this.loadPendingDocumentList(1);
    });
  }

  pendingDocumentSateValChange = (field, value) => {
    if (field === "page") {
      this.setState({ pendingDocumentCurrentPage: value }, () => {
        this.loadPendingDocumentList(value);
      });
    }
  };

  loadPendingDocumentList(offset) {
    showLoader("pendingDocumentListTable");
    this.setState({ pendingDocumentLoading: true });
    const { pendingDocumentSearchKeywords, pendingDocumentVessel, pendingDocumentPageLimit } = this.state;

    let addParam = `page=${offset}&limit=${pendingDocumentPageLimit?.value || adminlimit}`;
    if (pendingDocumentSearchKeywords !== "") {
      addParam += `&searchKeywords=${pendingDocumentSearchKeywords}`;
    }
    if (pendingDocumentVessel !== "") {
      addParam += `&vessel=${pendingDocumentVessel?.value || ""}`;
    }

    api
      .get(`${module}/get-onboard-document-status?${addParam}`)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ pendingDocumentList: res.data.result || [], pendingDocumentLoading: false });
          if (offset === 1) {
            this.setState({ pendingDocumentTotalRecords: res.data.totalRecord || 0, pendingDocumentTotalPage: res.data.totalPage || 0 });
          }
        } else {
          this.setState({ pendingDocumentLoading: false });
        }
        hideLoader("pendingDocumentListTable");
      })
      .catch((err) => {
        console.error(err);
        this.setState({ pendingDocumentLoading: false });
        hideLoader("pendingDocumentListTable");
      });
  }

  render() {
    const filterByUserDetails = this.state.filterByUserDetails?.value || "";
    const selectVessel_ = this.state.selectVessel;
    let selectedlistType = `${this.state.selectedlistType}${selectVessel_ !== "" ? "Vessel" : ""}`;
    console.log(selectedlistType, "selectedlistType");
    if (selectedlistType === "approved_count" || selectedlistType === "joined_count" || selectedlistType === "rejected_count") {
      selectedlistType = "proposed_count";
    } else if (selectedlistType === "signOffCount") {
      selectedlistType = "signOnCount";
    } else if (selectedlistType === "expiredDocuments") {
      selectedlistType = "dueforRenewal";
    } else if (selectedlistType === "signOnDG" || selectedlistType === "signOffDG" || selectedlistType === "aOAPending" || selectedlistType === "contractPending") {
      selectedlistType = "OnBoard";
    } else if (selectedlistType === "signOnDGVessel" || selectedlistType === "signOffDGVessel" || selectedlistType === "aOAPendingVessel" || selectedlistType === "contractPendingVessel") {
      selectedlistType = "OnBoardVessel";
    }

    const pageLimit = this.state.pageLimit?.value ?? 10;
    const pageLimitMedical = this.state.pageLimitMedical?.value ?? 10;
    const displyfiledfield = selectedlistType !== "" ? dashboardfield[selectedlistType] : null;
    const contractCardTypes = ["OnBoard", "dueforSignOff", "eocExpired", "dueforRenewal", "expiredDocuments", "signOnDG", "signOffDG", "aOAPending", "contractPending", "vesselposition"];
    let displyDays = "";
    if (selectedlistType !== "rankWiseAvailableCandidate" && !contractCardTypes.includes(this.state.selectedlistType)) {
      if (this.state.days === 1) {
        displyDays = "Today";
      } else if (this.state.days === 2) {
        displyDays = "Yesterday";
      } else if (this.state.days === 7) {
        displyDays = "Weekly";
      } else if (this.state.days === 30) {
        displyDays = "Monthly";
      }
    }

    const countableListTypes = ["signOnCount", "signOffCount", "OnBoard", "dueforSignOff", "eocExpired", "contractPending", "aOAPending", "signOffDG", "signOnDG"];
    const showViewCount = countableListTypes.includes(this.state.selectedlistType);

    return (
      <div>
        <div className="page">
          <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#extralargemodal" data-backdrop="static" data-keyboard="false" id="viewDetails">
            &nbsp;
          </button>
          <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#birthdayReminderModal" data-backdrop="static" data-keyboard="false" id="viewBirthdayReminder">
            &nbsp;
          </button>
          <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#reminderListModal" data-backdrop="static" data-keyboard="false" id="viewReminderList">
            &nbsp;
          </button>
          <button className="hidden" type="button" data-bs-toggle="modal" data-bs-target="#pendingDocumentModal" data-backdrop="static" data-keyboard="false" id="viewPendingDocument">
            &nbsp;
          </button>
          <div className="page-main">
            <Header currentPage={module} {...this.props} />

            <div className="main-content app-content">
              <div className="side-app">
                <div className="main-container container-fluid mx-3">
                  <div className="dashboard-container">
                    {/* HEADER */}

                    <div className="dashboard-header">
                      <div>
                        <h2>{moduleName}</h2>
                        <p>Indian Time: {format(new Date(), "yyyy MMM dd iii h:mm a")}</p>
                      </div>
                      <div style={{ display: "flex" }}>
                        <div className="filters">
                          <div className="form-group">
                            <div className="custom-controls-stacked">
                              <label className="custom-control custom-checkbox">
                                <input
                                  className="custom-control-input"
                                  type="checkbox"
                                  checked={this.state.filterByUser}
                                  name="filterByUser"
                                  onChange={this.handleChangeCheckbox.bind(this, "filterByUser")}
                                />
                                <span className="custom-control-label">Filter By User</span>
                              </label>
                            </div>
                          </div>
                          {this.state.filterByUser && (
                            <div className="row">
                              <div className="col-md-12">
                                <Select
                                  value={this.state.filterByUserDetails}
                                  onChange={this.handleSelectChange.bind(this, "filterByUserDetails")}
                                  placeholder={`Select User`}
                                  isClearable={true}
                                  options={this.state.userList}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        <div className="filters">
                          <button className={`${this.state.days === 1 ? "active" : ""}`} onClick={this.selectReportType.bind(this, 1)}>
                            Daily
                          </button>
                          <button className={`${this.state.days === 2 ? "active" : ""}`} onClick={this.selectReportType.bind(this, 2)}>
                            Yesterday
                          </button>
                          <button className={`${this.state.days === 7 ? "active" : ""}`} onClick={this.selectReportType.bind(this, 7)}>
                            Weekly
                          </button>
                          <button className={`${this.state.days === 30 ? "active" : ""}`} onClick={this.selectReportType.bind(this, 30)}>
                            Monthly
                          </button>
                        </div>

                        <div className="filters" style={{ marginLeft: "15px" }}>
                          <button type="button" onClick={this.openBirthdayReminder.bind(this)}>
                            <i className="fa fa-birthday-cake me-1" aria-hidden="true"></i> Birthday Reminder
                          </button>
                        </div>

                        <div className="filters" style={{ marginLeft: "15px" }}>
                          <button type="button" onClick={this.openReminderList.bind(this)}>
                            <i className="fa fa-bell me-1" aria-hidden="true"></i> Reminder
                          </button>
                        </div>

                        <div className="filters" style={{ marginLeft: "15px" }}>
                          <button type="button" onClick={this.openPendingDocument.bind(this)}>
                            <i className="fa fa-file-text-o me-1" aria-hidden="true"></i> Pending Document
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* KPI CARDS */}
                    <div className="kpi-grid">
                      {cards.map((card, index) => {
                        let showcard = true;
                        if (this.state.filterByUser) {
                          if (filterByUserDetails === "") {
                            showcard = false;
                          } else {
                            if (["signOnCount", "signOffCount"].indexOf(card.key) >= 0) {
                              showcard = false;
                            }
                          }
                        }
                        if (showcard) {
                          return (
                            <div className="kpi-card" key={index} onClick={this.viewDetails.bind(this, card.key, card.title, this.state[card.key] || 0)}>
                              {this.state.loading ? (
                                <>
                                  <div>
                                    <p>
                                      <Skeleton height={20} width={120} />
                                    </p>
                                    <p>
                                      <Skeleton height={35} width={60} style={{ marginTop: 10 }} />
                                    </p>
                                  </div>
                                  <div>
                                    {" "}
                                    <Skeleton circle width={40} height={40} style={{ marginTop: 10 }} />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>
                                    <p>{card.title}</p>
                                    <h3>{this.state[card.key] || 0}</h3>

                                    {card.change && <span className="increase">▲ {card.change}</span>}
                                  </div>

                                  <div className="icon">
                                    <i className={`fa ${card.icon}`} style={{ color: `${card.color}` }} aria-hidden="true"></i>
                                  </div>
                                </>
                              )}
                            </div>
                          );
                        } else {
                          return "";
                        }
                      })}
                    </div>

                    {/* CONTRACTS */}
                    {!this.state.filterByUser && (
                      <div>
                        <h4 className="section-title">Contracts</h4>
                        <div className="kpi-grid">
                          {contractcards.map((card, index) => (
                            <div className="kpi-card" key={index} onClick={this.viewDetails.bind(this, card.key, card.title, this.state[card.key] || 0)}>
                              {this.state.contractLoading ? (
                                <>
                                  <div>
                                    <p>
                                      <Skeleton height={20} width={120} />
                                    </p>
                                    <p>
                                      <Skeleton height={35} width={60} style={{ marginTop: 10 }} />
                                    </p>
                                  </div>
                                  <div>
                                    {" "}
                                    <Skeleton circle width={40} height={40} style={{ marginTop: 10 }} />
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div>
                                    <p>{card.title}</p>
                                    <h3>{this.state[card.key] || 0}</h3>
                                  </div>

                                  <div className="icon">
                                    <i className={`fa ${card.icon}`} style={{ color: `${card.color}` }} aria-hidden="true"></i>
                                  </div>
                                </>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* CHARTS */}
                    {!this.state.filterByUser && (
                      <div className="row">
                        <div className="col-md-12 col-xl-12">
                          <div className="card">
                            <div className="card-body">
                              {this.state.rankWiseloading ? (
                                <div>
                                  <Skeleton width={350} height={35} />

                                  <div style={{ marginTop: 30 }}>
                                    <Skeleton height={35} style={{ marginBottom: 25 }} />
                                    <Skeleton height={35} />
                                  </div>
                                </div>
                              ) : (
                                <HighchartsReact highcharts={Highcharts} options={this.state.chartOptions} />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="mt-4"></div>
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="card">
                          <div className="card-header">
                            <h3 className="card-title">User & Rank Wise Calls Made</h3>
                          </div>
                          <div className="card-body">
                            {this.state.rankWiseloading
                              ? showContaimerLoader()
                              : this.state.rankList.length > 0 && (
                                  <div className="table-responsive">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                      <thead className="table-primary">
                                        <tr>
                                          <th className="text-center" style={{ width: "200px" }}>
                                            User
                                          </th>
                                          {this.state.rankList.length > 0 &&
                                            this.state.rankList.map((item, index) => {
                                              return (
                                                <th className="text-center" key={index}>
                                                  {item}
                                                </th>
                                              );
                                            })}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.state.userandRankWiseList.length > 0 &&
                                          this.state.userandRankWiseList.map((item, index) => {
                                            let userrankList = item.rank.length > 0 ? item.rank : [];

                                            return (
                                              <tr key={index}>
                                                <td>{item.userName}</td>
                                                {this.state.rankList.map((rankItem, rankIndex) => {
                                                  const matchedRank = userrankList.find((x) => x.discussionranks === rankItem);
                                                  return (
                                                    <td key={rankIndex}>
                                                      {matchedRank ? (
                                                        <div className="bar-wrapper">
                                                          {parseInt(matchedRank.yesCount) > 0 ? <div className="bar yes">{matchedRank.yesCount}</div> : ""}

                                                          {parseInt(matchedRank.noCount) > 0 ? <div className="bar no">{matchedRank.noCount}</div> : ""}
                                                        </div>
                                                      ) : null}
                                                    </td>
                                                  );
                                                })}
                                              </tr>
                                            );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                )}
                          </div>
                        </div>
                      </div>
                    </div>
                    {!this.state.filterByUser && (
                      <>
                        <div className="mt-4"></div>
                        <div className="row">
                          <div className="col-md-12 col-xl-12">
                            <div className="card">
                              <div className="card-body">
                                {this.state.rankWiseAvailloading ? (
                                  <div>
                                    <Skeleton width={350} height={35} />

                                    <div style={{ marginTop: 30 }}>
                                      <Skeleton height={35} style={{ marginBottom: 25 }} />
                                      <Skeleton height={35} />
                                    </div>
                                  </div>
                                ) : (
                                  <HighchartsReact highcharts={Highcharts} options={this.state.rankWiseAvailchartOptions} />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {this.state.filterByUser && filterByUserDetails === "" && (
                      <div>
                        <div className="mt-4"></div>
                        <div className="row">
                          <div className="col-md-12 col-xl-12">
                            <div className="card">
                              <div className="card-body">
                                {this.state.userWiseLoading ? (
                                  <div>
                                    <Skeleton width={350} height={35} />

                                    <div style={{ marginTop: 30 }}>
                                      <Skeleton height={35} style={{ marginBottom: 25 }} />
                                      <Skeleton height={35} />
                                    </div>
                                  </div>
                                ) : (
                                  <HighchartsReact highcharts={Highcharts} options={this.state.userCallschartOptions} />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-4"></div>
                        <div className="row">
                          <div className="col-md-12 col-xl-12">
                            <div className="card">
                              <div className="card-body">
                                {this.state.userWiseLoading ? (
                                  <div>
                                    <Skeleton width={350} height={35} />

                                    <div style={{ marginTop: 30 }}>
                                      <Skeleton height={35} style={{ marginBottom: 25 }} />
                                      <Skeleton height={35} />
                                    </div>
                                  </div>
                                ) : (
                                  <HighchartsReact highcharts={Highcharts} options={this.state.userCreatedchartOptions} />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-4"></div>
                        <div className="row">
                          <div className="col-md-12 col-xl-12">
                            <div className="card">
                              <div className="card-body">
                                {this.state.userWiseLoading ? (
                                  <div>
                                    <Skeleton width={350} height={35} />

                                    <div style={{ marginTop: 30 }}>
                                      <Skeleton height={35} style={{ marginBottom: 25 }} />
                                      <Skeleton height={35} />
                                    </div>
                                  </div>
                                ) : (
                                  <HighchartsReact highcharts={Highcharts} options={this.state.userWisechartOptions} />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="extralargemodal" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {displyDays} {this.state.viewTitle || ""}
                  {showViewCount && <span style={{ color: "#ff0000cc", fontWeight: 700 }}> - {this.state.viewCount}</span>}
                </h5>
                <button className="btn-close" data-bs-dismiss="modal" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ display: !this.state.viewDocumentFile ? "none" : "" }}>
                  {this.state.viewDocumentFile && <iframe src={`${this.state.viewDocumentFile}`} width="100%" height="500px" title="View File"></iframe>}
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={this.viewFileBack.bind(this)}>
                      Back
                    </button>
                  </div>
                </div>

                {displyfiledfield !== null && (
                  <div style={{ display: this.state.viewDocumentFile ? "none" : "" }}>
                    {selectedlistType === "dueforRenewal" && (
                      <div className="tab-menu-heading">
                        <div className="tabs-menu">
                          <ul className="nav panel-tabs panel-secondary">
                            <li>
                              <a href="/" onClick={this.setactiveTab.bind(this, "doc")} className={this.state.activeTab === "doc" || this.state.activeTab === "" ? "active" : ""}>
                                <span>
                                  <i className="fe fe-user me-1"></i>
                                </span>
                                {this.state.selectedlistType === "expiredDocuments" ? "Expired Documents" : "Due for Renewal Documents"}
                              </a>
                            </li>
                            <li>
                              <a href="/" onClick={this.setactiveTab.bind(this, "medical")} className={this.state.activeTab === "medical" ? "active" : ""}>
                                <span>
                                  <i className="fe fe-calendar me-1"></i>
                                </span>
                                {this.state.selectedlistType === "expiredDocuments" ? "Expired Medical Documents" : "Due for Renewal Medical"}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}

                    <div className="tab-content">
                      {this.state.activeTab !== "medical" && (
                        <div className="tab-pane active">
                          <div className="card-header" style={{ paddingLeft: 0 }}>
                            {this.state.totalPage > 0 &&
                              showPageCount(this.state.viewTitle, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                          </div>
                          <div className="card-header" style={{ paddingLeft: 0 }}>
                            <div className="card-title"></div>
                            <div className="card-options" style={{ display: "block", width: "100%" }}>
                              <div className="form-row">
                                {this.state.selectedlistType === "vesselposition" && (
                                  <>
                                    <div className="form-group col-md-2">
                                      <DatePicker
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        placeholderText="Select From Date"
                                        className="form-control"
                                        onKeyDown={(e) => e.preventDefault()}
                                        selected={this.state.vlsposstartdate}
                                        dateFormat="dd-MM-yyyy"
                                        isClearable={this.state.vlsposstartdate!==""?true:false}
                                        onChange={this.handleDateChange.bind(this, "vlsposstartdate")}
                                      />
                                    </div>
                                    <div className="form-group col-md-2">
                                      <DatePicker
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        placeholderText="Select To Date"
                                        className="form-control"
                                        onKeyDown={(e) => e.preventDefault()}
                                        selected={this.state.vlsposend}
                                        minDate={this.state.vlsposstartdate !== "" ? addDays(new Date(this.state.vlsposstartdate), 1) : ""}
                                        dateFormat="dd-MM-yyyy"
                                        isClearable={this.state.vlsposend!==""?true:false}
                                        onChange={this.handleDateChange.bind(this, "vlsposend")}
                                      />
                                    </div>
                                    <div className="form-group col-md-3">
                                      <Select value={this.state.vesselID} onChange={this.handleDateChange.bind(this, "vesselID")} placeholder="Select Vessel" isClearable={true} options={this.state.vessleList} />
                                    </div>
                                    
                                  </>
                                )}

                                <div className={`col-md-${this.state.selectedlistType === "vesselposition"?'3':'4'}`}>
                                  <input
                                    className="form-control"
                                    placeholder="Search keyword"
                                    type="text"
                                    value={this.state.searchKeywords}
                                    onChange={(e) => {
                                      this.setState({ searchKeywords: e.target.value });
                                    }}
                                  />
                                </div>

                                <div className="col-md-1">
                                  <a
                                    href="/"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.loadDetailsList(1);
                                    }}
                                    className="btn btn-primary"
                                  >
                                    Search
                                  </a>
                                </div>
                                {this.state.selectVessel !== "" && (
                                  <div className="col-md-3">
                                    <a
                                      href="/"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({ selectVessel: "" }, () => {
                                          this.loadDetailsList(1);
                                        });
                                      }}
                                      className="btn btn-danger"
                                    >
                                      Back
                                    </a>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="table-responsive table-wrapper" style={{ maxHeight: `${parseFloat(this.state.windowHeight) - 200}px`, minHeight: "200px" }} id="seletedDataList">
                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 custom-table">
                              <thead className="table-primary">
                                <tr>
                                  {displyfiledfield.fieldName.map((item, index) => {
                                    return <th key={index}>{item.label}</th>;
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.selectedlistData.length > 0
                                  ? this.state.selectedlistData.map((item, index) => {
                                      let totalDays = "";
                                      let displayColor = "";
                                      if (selectedlistType === "dueforSignOff" || selectedlistType === "dueforRenewal" || selectedlistType === "expiredDocuments") {
                                        if (item.contractExtensionDate !== null && item.contractExtensionDate !== "" && item.contractExtensionDate !== "1970-01-01") {
                                          totalDays = getDaysBetweenDates(new Date(), item.contractExtensionDate);
                                        } else {
                                          totalDays = getDaysBetweenDates(new Date(), item.eoc);
                                        }

                                        if (parseFloat(totalDays) <= 7) {
                                          displayColor = "table-dangers";
                                        } else if (parseFloat(totalDays) > 7 && parseFloat(totalDays) <= 15) {
                                          displayColor = "table-orange";
                                        } else if (parseFloat(totalDays) > 15) {
                                          displayColor = "table-yellow";
                                        }
                                      }

                                      return (
                                        <tr key={index} className={`${displayColor}`}>
                                          {displyfiledfield.fieldName.map((fitem, findex) => {
                                            if (fitem.name === "candidateId") {
                                              return (
                                                <td key={findex}>
                                                  <a href={`/candidate/view/${item[fitem.name]}`} target="_blank" rel="noreferrer">
                                                    {item[fitem.name]}
                                                  </a>
                                                </td>
                                              );
                                            } else if (fitem.datatype === "link") {
                                              return (
                                                <td key={findex}>
                                                  <a href={`/`} onClick={this.onSelectVessel.bind(this, item.vslName)}>
                                                    {item[fitem.name]}
                                                  </a>
                                                </td>
                                              );
                                            } else if (fitem.datatype === "file") {
                                              let viewFile_ = "";
                                              let viewDocumentTitle_ = "";
                                              if (selectedlistType === "dueforRenewal") {
                                                viewFile_ = item.document_files !== "" && item.document_files !== null ? `${downloadUrl}views/public/files/${item.document_files}` : "";
                                                viewDocumentTitle_ = `View Document - ${item.document}(${item.candidateId})`;
                                              }
                                              return (
                                                <td className="text-center" key={findex}>
                                                  {item[fitem.name] !== "" && item[fitem.name] !== null && (
                                                    <a href="/" onClick={this.viewFile.bind(this, viewFile_, viewDocumentTitle_)}>
                                                      <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                    </a>
                                                  )}
                                                </td>
                                              );
                                            } else if (fitem.name === "eocDate") {
                                              const contractExtensionDate = item.contractExtensionDate || "";
                                              return (
                                                <td key={findex}>
                                                  {contractExtensionDate !== "" && contractExtensionDate !== null && contractExtensionDate !== "1970-01-01"
                                                    ? showDate(contractExtensionDate)
                                                    : showDate(item.eoc)}
                                                </td>
                                              );
                                            } else if (fitem.name === "eoc_status") {
                                              const contractExtensionDate = item.contractExtensionDate || "";
                                              const statusColor =
                                                contractExtensionDate !== "" && contractExtensionDate !== null && contractExtensionDate !== "1970-01-01"
                                                  ? calculateStatus_(contractExtensionDate)
                                                  : calculateStatus_(item.eoc);

                                              return (
                                                <td className="text-center" key={findex}>
                                                  <span className={`badge bg-${statusColor?.color} badge-sm  me-2 mb-2 mt-2`}>{statusColor?.status || ""}</span>
                                                </td>
                                              );
                                            } else if (fitem.datatype === "r_date_status") {
                                              const r_date = item[fitem.name] || "";
                                              const statusColor = calculateStatus_(r_date);
                                              return (
                                                <td className="text-center" key={findex}>
                                                  <span className={`badge bg-${statusColor?.color} badge-sm  me-2 mb-2 mt-2`}>{statusColor?.status || ""}</span>
                                                </td>
                                              );
                                            } else {
                                              let displayVal = "";
                                              if (fitem.name === "sno") {
                                                displayVal = (this.state.currentPage - 1) * parseInt(pageLimit) + parseInt(index) + 1;
                                              } else if (fitem?.datatype === "date") {
                                                displayVal = showDate(item[fitem.name]);
                                              } else if (fitem?.datatype === "datetime") {
                                                displayVal = showDateTime(item[fitem.name]);
                                              } else if (fitem?.datatype === "html") {
                                                displayVal = showHTMLText(item[fitem.name] || "");
                                              } else {
                                                displayVal = item[fitem.name];
                                              }
                                              return <td key={findex}>{displayVal}</td>;
                                            }
                                          })}
                                        </tr>
                                      );
                                    })
                                  : null}
                              </tbody>
                            </table>
                          </div>
                          {this.state.totalPage > 1 && (
                            <Pagenation
                              params={{
                                totalRecords: this.state.totalRecords,
                                totalPage: this.state.totalPage,
                                currentPage: this.state.currentPage,
                                addParam: this.state.selectedlistType,
                              }}
                              sateValChange={this.sateValChange}
                            />
                          )}
                        </div>
                      )}
                      {this.state.activeTab === "medical" && (
                        <div className="tab-pane active">
                          <div className="card-header" style={{ paddingLeft: 0 }}>
                            {this.state.totalPage > 0 &&
                              showPageCount(
                                "Medical",
                                this.state.currentPageMedical,
                                this.state.totalPageMedical,
                                this.state.totalRecordsMedical,
                                this.sateValChange,
                                this.state.pageLimitMedical,
                                "Medical",
                              )}
                          </div>
                          <div className="table-responsive table-wrapper" style={{ maxHeight: `${parseFloat(this.state.windowHeight) - 100}px`, minHeight: "200px" }} id="seletedDataList">
                            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 custom-table">
                              <thead className="table-primary">
                                <tr>
                                  {dashboardfield.dueforRenewalMedical.fieldName.map((item, index) => {
                                    return <th key={index}>{item.label}</th>;
                                  })}
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.selectedlistDataMedical.length > 0
                                  ? this.state.selectedlistDataMedical.map((item, index) => {
                                      let displayColor = "";

                                      let totalDays = getDaysBetweenDates(new Date(), item.expiry_date);

                                      if (parseFloat(totalDays) <= 7) {
                                        displayColor = "table-dangers";
                                      } else if (parseFloat(totalDays) > 7 && parseFloat(totalDays) <= 15) {
                                        displayColor = "table-orange";
                                      } else if (parseFloat(totalDays) > 15) {
                                        displayColor = "table-yellow";
                                      }

                                      return (
                                        <tr key={index} className={`${displayColor}`}>
                                          {dashboardfield.dueforRenewalMedical.fieldName.map((fitem, findex) => {
                                            if (fitem.name === "candidateId") {
                                              return (
                                                <td key={findex}>
                                                  <a href={`/candidate/view/${item[fitem.name]}`} target="_blank" rel="noreferrer">
                                                    {item[fitem.name]}
                                                  </a>
                                                </td>
                                              );
                                            } else if (fitem.datatype === "link") {
                                              return (
                                                <td key={findex}>
                                                  <a href={`/`} onClick={this.onSelectVessel.bind(this, item.vslName)}>
                                                    {item[fitem.name]}
                                                  </a>
                                                </td>
                                              );
                                            } else if (fitem.datatype === "file") {
                                              let viewFile_ = "";
                                              let viewDocumentTitle_ = "";
                                              console.log(item, "itemitemitemitem");
                                              if (selectedlistType === "dueforRenewal") {
                                                viewFile_ = item.upload !== "" && item.upload !== null ? `${downloadUrl}views/public/uploads/medical/${item.upload}` : "";
                                                viewDocumentTitle_ = `View Medical(${item.candidateId})`;
                                              }
                                              return (
                                                <td className="text-center" key={findex}>
                                                  {item[fitem.name] !== "" && item[fitem.name] !== null && (
                                                    <a href="/" onClick={this.viewFile.bind(this, viewFile_, viewDocumentTitle_)}>
                                                      <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                    </a>
                                                  )}
                                                </td>
                                              );
                                            } else {
                                              let displayVal = "";
                                              if (fitem.name === "sno") {
                                                displayVal = (this.state.currentPageMedical - 1) * parseInt(pageLimitMedical) + parseInt(index) + 1;
                                              } else if (fitem?.datatype === "date") {
                                                displayVal = showDate(item[fitem.name]);
                                              } else if (fitem?.datatype === "datetime") {
                                                displayVal = showDateTime(item[fitem.name]);
                                              } else if (fitem?.datatype === "html") {
                                                displayVal = showHTMLText(item[fitem.name] || "");
                                              } else {
                                                displayVal = item[fitem.name];
                                              }
                                              return <td key={findex}>{displayVal}</td>;
                                            }
                                          })}
                                        </tr>
                                      );
                                    })
                                  : null}
                              </tbody>
                            </table>
                          </div>
                          {this.state.totalPageMedical}
                          {this.state.totalPageMedical > 1 && (
                            <Pagenation
                              params={{
                                totalRecords: this.state.totalRecordsMedical,
                                totalPage: this.state.totalPageMedical,
                                currentPage: this.state.currentPageMedical,
                                addParam: "Medical",
                              }}
                              sateValChange={this.sateValChange}
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="birthdayReminderModal" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Birthday Reminder</h5>
                <button className="btn-close" data-bs-dismiss="modal" onClick={this.closeBirthdayReminder.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="card-header" style={{ paddingLeft: 0 }}>
                  <h3 className="card-title">
                    Page: <b>{this.state.birthdayCurrentPage}</b> of <b>{this.state.birthdayTotalPage}</b>, Total Record: {this.state.birthdayTotalRecords}
                  </h3>
                  <div className="card-options">
                    <label className="mx-3 mt-2">Page Per</label>
                    <Select
                      value={this.state.birthdayPageLimit}
                      onChange={(selectedOption) => {
                        this.setState({ birthdayPageLimit: selectedOption || { label: adminlimit, value: adminlimit }, birthdayCurrentPage: 1 }, () => {
                          this.loadBirthdayReminder(1);
                        });
                      }}
                      placeholder="Page Per"
                      options={[
                        { value: "10", label: "10" },
                        { value: "25", label: "25" },
                        { value: "50", label: "50" },
                        { value: "100", label: "100" },
                      ]}
                    />
                  </div>
                </div>
                <div className="card-header" style={{ paddingLeft: 0 }}>
                  <div className="card-title"></div>
                  <div className="card-options" style={{ display: "block", width: "100%" }}>
                    <div className="form-row">
                      <div className="form-group col-md-2">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select From Date"
                          className="form-control"
                          onKeyDown={(e) => e.preventDefault()}
                          selected={this.state.birthdayStartDate}
                          dateFormat="dd-MM-yyyy"
                          isClearable={this.state.birthdayStartDate !== ""}
                          onChange={this.handleBirthdayDateChange.bind(this, "birthdayStartDate")}
                        />
                      </div>
                      <div className="form-group col-md-2">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select To Date"
                          className="form-control"
                          onKeyDown={(e) => e.preventDefault()}
                          selected={this.state.birthdayEndDate}
                          minDate={this.state.birthdayStartDate !== "" ? this.state.birthdayStartDate : ""}
                          dateFormat="dd-MM-yyyy"
                          isClearable={this.state.birthdayEndDate !== ""}
                          onChange={this.handleBirthdayDateChange.bind(this, "birthdayEndDate")}
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          className="form-control"
                          placeholder="Search by name, rank or vessel"
                          type="text"
                          value={this.state.birthdaySearchKeywords}
                          onChange={(e) => {
                            this.setState({ birthdaySearchKeywords: e.target.value });
                          }}
                        />
                      </div>
                      <div className="col-md-1">
                        <a href="/" onClick={this.birthdaySearchBirthdayReminder.bind(this)} className="btn btn-primary">
                          Search
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive table-wrapper" style={{ maxHeight: `${parseFloat(this.state.windowHeight) - 200}px`, minHeight: "200px" }} id="birthdayReminderList">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 custom-table">
                    <thead className="table-primary">
                      <tr>
                        <th>S.No</th>
                        <th>Candidate Id</th>
                        <th>Name</th>
                        <th>DOB</th>
                        <th>Next Birthday</th>
                        <th>Rank</th>
                        <th>Vessel</th>
                        <th>Mobile</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.birthdayReminderList.length > 0
                        ? this.state.birthdayReminderList.map((item, index) => {
                            const pageLimitValue = this.state.birthdayPageLimit?.value || adminlimit;
                            return (
                              <tr key={index}>
                                <td>{(this.state.birthdayCurrentPage - 1) * parseInt(pageLimitValue) + parseInt(index) + 1}</td>
                                <td>
                                  <a href={`/candidate/view/${item.candidateId}`} target="_blank" rel="noreferrer">
                                    {item.candidateId}
                                  </a>
                                </td>
                                <td>{item.name}</td>
                                <td>{showDate(item.dob)}</td>
                                <td>{showDate(item.nextBirthday)}</td>
                                <td>{item.c_rank}</td>
                                <td>{item.c_vessel}</td>
                                <td>{item.c_mobi1}</td>
                                <td>{item.email1}</td>
                              </tr>
                            );
                          })
                        : !this.state.birthdayLoading && (
                            <tr>
                              <td colSpan={9} className="text-center">
                                No birthday reminders found
                              </td>
                            </tr>
                          )}
                    </tbody>
                  </table>
                </div>
                {this.state.birthdayTotalPage > 1 && (
                  <Pagenation
                    params={{
                      totalRecords: this.state.birthdayTotalRecords,
                      totalPage: this.state.birthdayTotalPage,
                      currentPage: this.state.birthdayCurrentPage,
                      addParam: "",
                    }}
                    sateValChange={this.birthdaySateValChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="reminderListModal" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reminder</h5>
                <button className="btn-close" data-bs-dismiss="modal" onClick={this.closeReminderList.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="card-header" style={{ paddingLeft: 0 }}>
                  <h3 className="card-title">
                    Page: <b>{this.state.reminderCurrentPage}</b> of <b>{this.state.reminderTotalPage}</b>, Total Record: {this.state.reminderTotalRecords}
                  </h3>
                  <div className="card-options">
                    <label className="mx-3 mt-2">Page Per</label>
                    <Select
                      value={this.state.reminderPageLimit}
                      onChange={(selectedOption) => {
                        this.setState({ reminderPageLimit: selectedOption || { label: adminlimit, value: adminlimit }, reminderCurrentPage: 1 }, () => {
                          this.loadReminderList(1);
                        });
                      }}
                      placeholder="Page Per"
                      options={[
                        { value: "10", label: "10" },
                        { value: "25", label: "25" },
                        { value: "50", label: "50" },
                        { value: "100", label: "100" },
                      ]}
                    />
                  </div>
                </div>
                <div className="card-header" style={{ paddingLeft: 0 }}>
                  <div className="card-title"></div>
                  <div className="card-options" style={{ display: "block", width: "100%" }}>
                    <div className="form-row">
                      <div className="form-group col-md-2">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select From Date"
                          className="form-control"
                          onKeyDown={(e) => e.preventDefault()}
                          selected={this.state.reminderStartDate}
                          dateFormat="dd-MM-yyyy"
                          isClearable={this.state.reminderStartDate !== ""}
                          onChange={this.handleReminderDateChange.bind(this, "reminderStartDate")}
                        />
                      </div>
                      <div className="form-group col-md-2">
                        <DatePicker
                          peekNextMonth
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          placeholderText="Select To Date"
                          className="form-control"
                          onKeyDown={(e) => e.preventDefault()}
                          selected={this.state.reminderEndDate}
                          minDate={this.state.reminderStartDate !== "" ? this.state.reminderStartDate : ""}
                          dateFormat="dd-MM-yyyy"
                          isClearable={this.state.reminderEndDate !== ""}
                          onChange={this.handleReminderDateChange.bind(this, "reminderEndDate")}
                        />
                      </div>
                      <div className="col-md-4">
                        <input
                          className="form-control"
                          placeholder="Search by name, rank or vessel"
                          type="text"
                          value={this.state.reminderSearchKeywords}
                          onChange={(e) => {
                            this.setState({ reminderSearchKeywords: e.target.value });
                          }}
                        />
                      </div>
                      <div className="col-md-1">
                        <a href="/" onClick={this.reminderSearchList.bind(this)} className="btn btn-primary">
                          Search
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive table-wrapper" style={{ maxHeight: `${parseFloat(this.state.windowHeight) - 200}px`, minHeight: "200px" }} id="reminderListTable">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 custom-table">
                    <thead className="table-primary">
                      <tr>
                        <th>S.No</th>
                        <th>Candidate Id</th>
                        <th>Name</th>
                        <th>Reminder Date</th>
                        <th>Discussion</th>
                        <th>Posted By</th>
                        <th>Rank</th>
                        <th>Vessel</th>
                        <th>Mobile</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.reminderList.length > 0
                        ? this.state.reminderList.map((item, index) => {
                            const pageLimitValue = this.state.reminderPageLimit?.value || adminlimit;
                            return (
                              <tr key={index}>
                                <td>{(this.state.reminderCurrentPage - 1) * parseInt(pageLimitValue) + parseInt(index) + 1}</td>
                                <td>
                                  <a href={`/candidate/view/${item.candidateId}`} target="_blank" rel="noreferrer">
                                    {item.candidateId}
                                  </a>
                                </td>
                                <td>{item.name}</td>
                                <td>{showDate(item.r_date)}</td>
                                <td>{showHTMLText(item.discussion || "")}</td>
                                <td>{item.userName}</td>
                                <td>{item.c_rank}</td>
                                <td>{item.c_vessel}</td>
                                <td>{item.c_mobi1}</td>
                                <td>{item.email1}</td>
                              </tr>
                            );
                          })
                        : !this.state.reminderLoading && (
                            <tr>
                              <td colSpan={10} className="text-center">
                                No reminders found
                              </td>
                            </tr>
                          )}
                    </tbody>
                  </table>
                </div>
                {this.state.reminderTotalPage > 1 && (
                  <Pagenation
                    params={{
                      totalRecords: this.state.reminderTotalRecords,
                      totalPage: this.state.reminderTotalPage,
                      currentPage: this.state.reminderCurrentPage,
                      addParam: "",
                    }}
                    sateValChange={this.reminderSateValChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade" id="pendingDocumentModal" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-full-width" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Pending Document</h5>
                <button className="btn-close" data-bs-dismiss="modal" onClick={this.closePendingDocument.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="card-header" style={{ paddingLeft: 0 }}>
                  <h3 className="card-title">
                    Page: <b>{this.state.pendingDocumentCurrentPage}</b> of <b>{this.state.pendingDocumentTotalPage}</b>, Total Record: {this.state.pendingDocumentTotalRecords}
                  </h3>
                  <div className="card-options">
                    <label className="mx-3 mt-2">Page Per</label>
                    <Select
                      value={this.state.pendingDocumentPageLimit}
                      onChange={(selectedOption) => {
                        this.setState({ pendingDocumentPageLimit: selectedOption || { label: adminlimit, value: adminlimit }, pendingDocumentCurrentPage: 1 }, () => {
                          this.loadPendingDocumentList(1);
                        });
                      }}
                      placeholder="Page Per"
                      options={[
                        { value: "10", label: "10" },
                        { value: "25", label: "25" },
                        { value: "50", label: "50" },
                        { value: "100", label: "100" },
                      ]}
                    />
                  </div>
                </div>
                <div className="card-header" style={{ paddingLeft: 0 }}>
                  <div className="card-title"></div>
                  <div className="card-options" style={{ display: "block", width: "100%" }}>
                    <div className="form-row">
                      <div className="col-md-4">
                        <input
                          className="form-control"
                          placeholder="Search by candidate id, name, rank or vessel"
                          type="text"
                          value={this.state.pendingDocumentSearchKeywords}
                          onChange={(e) => {
                            this.setState({ pendingDocumentSearchKeywords: e.target.value });
                          }}
                        />
                      </div>
                      <div className="col-md-3">
                        <Select
                          value={this.state.pendingDocumentVessel}
                          onChange={(selectedOption) => {
                            this.setState({ pendingDocumentVessel: selectedOption || "", pendingDocumentCurrentPage: 1 }, () => {
                              this.loadPendingDocumentList(1);
                            });
                          }}
                          placeholder="Select Vessel"
                          isClearable={true}
                          options={this.state.vessleList}
                        />
                      </div>
                      <div className="col-md-1">
                        <a href="/" onClick={this.pendingDocumentSearchList.bind(this)} className="btn btn-primary">
                          Search
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="table-responsive table-wrapper" style={{ maxHeight: `${parseFloat(this.state.windowHeight) - 250}px`, minHeight: "200px" }} id="pendingDocumentListTable">
                  <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 custom-table">
                    <thead className="table-primary">
                      <tr>
                        <th>S.No</th>
                        <th>Candidate Id</th>
                        <th>Name</th>
                        <th>Rank</th>
                        <th>Vessel Name</th>
                        <th>Vessel Type</th>
                        <th>Company</th>
                        <th className="text-center">Passport</th>
                        <th className="text-center">CDC</th>
                        <th className="text-center">Bank</th>
                        <th className="text-center">Travel</th>
                        <th className="text-center">Medical</th>
                        <th className="text-center">NDK</th>
                        <th className="text-center">COE</th>
                        <th className="text-center">AOA</th>
                        <th className="text-center">DG FORM-1-S/On</th>
                        <th className="text-center">OFF 11</th>
                        <th className="text-center">OFF 14</th>
                        <th className="text-center">OFF 15</th>
                        <th className="text-center">OFF 42</th>
                        <th className="text-center">OFF 44</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.pendingDocumentList.length > 0
                        ? this.state.pendingDocumentList.map((item, index) => {
                            const pageLimitValue = this.state.pendingDocumentPageLimit?.value || adminlimit;
                            return (
                              <tr key={index}>
                                <td>{(this.state.pendingDocumentCurrentPage - 1) * parseInt(pageLimitValue) + parseInt(index) + 1}</td>
                                <td>
                                  <a href={`/candidate/view/${item.candidateId}`} target="_blank" rel="noreferrer">
                                    {item.candidateId}
                                  </a>
                                </td>
                                <td>{item.name}</td>
                                <td>{item.contractRank}</td>
                                <td>{item.vesselName}</td>
                                <td>{item.vesselType}</td>
                                <td>{item.company_name}</td>
                                <td className="text-center">{renderDocStatus(item.passport)}</td>
                                <td className="text-center">{renderDocStatus(item.cdc)}</td>
                                <td className="text-center">{renderDocStatus(item.bank)}</td>
                                <td className="text-center">{renderDocStatus(item.travel)}</td>
                                <td className="text-center">{renderDocStatus(item.medical)}</td>
                                <td className="text-center">{renderDocStatus(item.ndk)}</td>
                                <td className="text-center">{renderDocStatus(item.coe)}</td>
                                <td className="text-center">{renderDocStatus(item.aoa)}</td>
                                <td className="text-center">{renderDocStatus(item.dgForm1SignOn)}</td>
                                <td className="text-center">{renderDocStatus(item.off11)}</td>
                                <td className="text-center">{renderDocStatus(item.off14)}</td>
                                <td className="text-center">{renderDocStatus(item.off15)}</td>
                                <td className="text-center">{renderDocStatus(item.off42)}</td>
                                <td className="text-center">{renderDocStatus(item.off44)}</td>
                              </tr>
                            );
                          })
                        : !this.state.pendingDocumentLoading && (
                            <tr>
                              <td colSpan={21} className="text-center">
                                No records found
                              </td>
                            </tr>
                          )}
                    </tbody>
                  </table>
                </div>
                {this.state.pendingDocumentTotalPage > 1 && (
                  <Pagenation
                    params={{
                      totalRecords: this.state.pendingDocumentTotalRecords,
                      totalPage: this.state.pendingDocumentTotalPage,
                      currentPage: this.state.pendingDocumentCurrentPage,
                      addParam: "",
                    }}
                    sateValChange={this.pendingDocumentSateValChange}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default List;
